module.exports = __webpack_public_path__ + "static/media/Calendar-1.76038d2b.png";